module.exports = __webpack_public_path__ + "img/arrows-right.46e75197.svg";